import styled, { keyframes, css } from "styled-components";
import { FullyCentered } from "styled/alignment/Center";
import colors from "theme/colors";
import sizes from "theme/sizes";
import indexPriority from "theme/z-index";
import breakpoints from 'theme/breakpoints';
import { Column } from "styled/alignment/Column";

const slideUp = keyframes`
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
`;

export const StyledModalOverlay = styled(FullyCentered)`
    z-index: ${indexPriority.modal};
    position: fixed;
    left: ${sizes.none};
    background: rgba(26, 26, 26, .9);
    width: 100%;
    height: 100dvh;
    top: ${sizes.none};
    padding: ${sizes.gigantic};
    &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100dvh;
        z-index: ${indexPriority.titanic};
        background: rgba(0, 0, 0, .1);

    }

    ${({ size }) => size === 'large' && `
        padding: 0 !important;
    `}


    ${({ size }) => size === 'xLarge' && `
        padding: 0 !important;
    `}

    ${({ size }) => size === 'fullscreen' && `
        padding: 0 !important;
    `}

    ${({ mobileSheet }) => mobileSheet && `
        @media screen and (max-width: 899px) {
            padding: 0 !important;
            align-items: flex-end;
            justify-content: flex-end;
            z-index: 9999;
        }
    `}
`;

export const StyledModal = styled(FullyCentered)`
    position: relative;
    width: 400px;
    max-height: 500px;
    flex-direction: column;
    background: ${colors.neutralLight};
    padding: ${sizes.gigantic} ${sizes.large} ${sizes.big} ${sizes.large};
    border-radius: 12px;
    z-index: ${indexPriority.max};
    /* overflow-x: hidden; */
    overflow: auto;

    ${({ size }) => size === 'large' && `
        width: 100%;
        min-height: 100%;
        max-height: 100%;
        border-radius: 0;
        padding-top: 70px;

        @media screen and (min-width: ${breakpoints.lg}) {
            width: 55%;
            min-height: 400px;
            max-height: 85vh;
            border-radius: 8px;
        }
    `}


${({ size }) => size === 'xLarge' && `
        width: 100%;
        min-height: 100%;
        max-height: 100%;
        border-radius: 0;
        padding-top: 70px;

        @media screen and (min-width: ${breakpoints.lg}) {
            width: 85%;
            min-height: 400px;
            max-height: 70%;
            border-radius: 8px;
        }
    `}

    ${({ size }) => size === 'fullscreen' && `
        width: 100%;
        min-height: 100%;
        max-height: 100%;
        border-radius: 0;
        padding-top: 70px;

        @media screen and (min-width: ${breakpoints.lg}) {
            width: calc(100% - 32px);
            min-height: calc(100dvh - 32px);
            max-height: calc(100dvh - 32px);
            border-radius: 12px;
        }
    `}

    ${({ size }) => size === 'medium' && `
        width: 100%;
        min-height: 100%;
        max-height: 100%;
        border-radius: 0;
        padding-top: 70px;

        @media screen and (min-width: ${breakpoints.lg}) {
            width: 45%;
            min-height: 400px;
            max-height: 85vh;
            border-radius: 20px;
        }
    `}
`;

export const StyledModalV2 = styled(Column)`
    position: relative;
    width: 480px;
    min-height: auto;
    max-height: 500px;
    background: ${colors.neutralLight};
    /* padding: ${sizes.gigantic} ${sizes.large} ${sizes.big} ${sizes.large}; */
    border-radius: 12px;
    z-index: ${indexPriority.max};
    overflow-x: hidden;
    overflow-y: auto;

    ${({ size }) => size === 'large' && `
        width: 100%;
        min-height: 100%;
        max-height: 100%;
        border-radius: 0;

        @media screen and (min-width: ${breakpoints.lg}) {
            width: 55%;
            min-height: 400px;
            max-height: 85vh;
            border-radius: 8px;
        }
    `}


${({ size }) => size === 'xLarge' && `
        width: 100%;
        min-height: 100%;
        max-height: 100%;
        border-radius: 0;

        @media screen and (min-width: ${breakpoints.lg}) {
            width: 85%;
            min-height: 400px;
            max-height: 70%;
            border-radius: 8px;
        }
    `}

    ${({ size }) => size === 'medium' && `
        width: 100%;
        min-height: 100%;
        max-height: 100%;
        border-radius: 0;

        @media screen and (min-width: ${breakpoints.lg}) {
            width: 48%;
            min-height: 400px;
            max-height: 90vh;
            border-radius: 24px;
        }
    `}

    ${({ mobileSheet }) => mobileSheet && css`
        @media screen and (max-width: 899px) {
            width: 100% !important;
            min-height: unset !important;
            max-height: 92dvh !important;
            border-radius: 16px 16px 0 0 !important;
            align-self: flex-end;
            animation: ${slideUp} 0.3s cubic-bezier(0.32, 0.72, 0, 1) both;
            overflow-y: auto;
            overflow-x: hidden;
            padding-bottom: env(safe-area-inset-bottom, 0px);
        }
    `}
`;

export const StyledModalContent = styled.div`
    text-align: ${props => props.textAlign};
    width: 100%;
    height: auto;

    // overflow-y
    ${props => {
        switch(props.overflowY) {
            case 'scroll':
                return `
                    flex: 1 1;
                    height: 0;
                `;
            default:
                return '';
        }
    }}
`;

export const StyledModalContentV2 = styled.div`
    text-align: ${props => props.textAlign};
    width: 100%;
    height: 100%;

    ${({ align }) => align === 'top-center' && `
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    `}
    
    ${({ align }) => align === 'center-center' && `
        flex-direction: column;
        align-items: center;
        justify-content: center;
    `}
    
    ${({ align }) => align === 'center-left' && `
        flex-direction: column;
        align-items: center;
        justify-content: left;
    `}

    
    ${({ align }) => align === 'top-left' && `
        flex-direction: column;
        align-items: flex-start;
        justify-content: left;
    `}

`;

export const StyledCloseModal = styled.div`
    position: absolute;
    top: ${sizes.little};
    right: ${sizes.little};
    width: ${sizes.intermediary};
    height: ${sizes.intermediary};
    cursor: pointer;

    ${({ circular }) => circular && `
        background: ${colors.neutralLight};
        opacity: 80%;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        padding: 8px;
        z-index: ${indexPriority.max};

        & > svg {
            fill: ${colors.nightDark};
        }
    `}

    & > svg {
        transition: all ease-in-out .3s;
    }
    
    &:hover {
        & > svg {
            fill: ${colors.nightDark};
        }
    }
`;

